// stores/useStore.js
import create from "zustand";

const useStore = create((set) => ({
  data: null,
  scrollPosition: 0,
  setScrollPosition: (position) => set({ scrollPosition: position }),
  setData: (data) => set({ data }),
  searchQuery: "",
  lastTrackedQuery: "",
  setSearchQuery: (query) => set({ searchQuery: query, scrollPosition: 0 }),
  isSearchOpen: false,
  setIsSearchOpen: (isSearchOpen) => {
    set({ isSearchOpen });
  },
  shouldSearchReopen: false,
  setShouldSearchReopen: (shouldSearchReopen) => {
    set({ shouldSearchReopen });
  },
  setLastTrackedQuery: (query) => set({ lastTrackedQuery: query }),
}));

export default useStore;
